export function useReportsPage() {
  return { title: 'Отчёты', description: 'Аналитика и выгрузки' };
}
